// Vike hook: fires when a client-side navigation starts. Mirrors React Router's
// `useNavigation().state === "loading"` so <LoaderBar> can show progress.
// eslint-disable-next-line no-restricted-imports
import { setNavigationState } from "../src/shared/Router/transitionStore";

export function onPageTransitionStart() {
  setNavigationState("loading");
}
